import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import DialogContentText from '@mui/material/DialogContentText';
import { Fragment } from 'react';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { PanelItemDivider } from '../../panels/panelItemDivider';
import { addMessageBox } from '../../redux/actions/messageBoxesActions';
import { thunkShowPlayerInfo } from '../../redux/actions/playerInfoActions';
import { useAppDispatch } from '../../redux/store';
import { DEFAULT_BACKGROUND_HOVER_COLOR, LIGHT_BLUE_COLOR, MODAL_HEADER_BACKGROUND_COLOR } from '../../styles/colors';
import { assertUnreachable } from '../../utils/tsUtils';
import { TwemojiWrapper } from '../twemojiWrapper';
const TABLE_CSS = css `
  width: 100%;
  border-spacing: 0;
  td {
    padding: 0 15px;
    vertical-align: top;
  }
  td:first-of-type {
    padding-left: 0;
  }
  td:last-of-type {
    padding-right: 0;
  }
`;
const HEADER_CSS = css `
  color: white;
`;
const DESCRIPTION_CSS = css `
  color: ${LIGHT_BLUE_COLOR};
  padding-bottom: 15px;
`;
const TR_LINK_CSS = css `
  cursor: pointer;
  &:hover {
    background-color: ${DEFAULT_BACKGROUND_HOVER_COLOR};
  }
`;
const renderTableDivider = (colSpan, color) => (_jsx("tr", { children: _jsx("td", { colSpan: colSpan, children: _jsx(PanelItemDivider, { color: color, thicknessPx: 2, marginPx: 0 }) }) }));
export const TableMessageBoxContents = ({ description, headers, rows, onClose }) => {
    const dispatch = useAppDispatch();
    const socketSend = useSocketSend();
    const getRowOnClick = (clickAction) => {
        if (!clickAction) {
            return;
        }
        switch (clickAction.type) {
            case 'show-player-info': {
                return () => {
                    onClose();
                    dispatch(thunkShowPlayerInfo(clickAction.player, socketSend));
                };
            }
            case 'show-test-email-details': {
                return () => {
                    onClose();
                    dispatch(addMessageBox({ type: 'test-email-details', emailMessage: clickAction.emailMessage }));
                };
            }
            default: {
                assertUnreachable(clickAction);
            }
        }
    };
    return (_jsx(DialogContentText, { component: 'div', children: _jsxs(TwemojiWrapper, { children: [description ? _jsx("div", { css: DESCRIPTION_CSS, children: description }) : undefined, _jsxs("table", { css: TABLE_CSS, children: [_jsxs("thead", { children: [_jsx("tr", { css: HEADER_CSS, children: headers.map((header, i) => (_jsx("td", { children: header }, i))) }), renderTableDivider(headers.length, 'white')] }), _jsx("tbody", { children: rows.map((row, i) => {
                                const onClick = getRowOnClick(row.clickAction);
                                const trCss = onClick ? TR_LINK_CSS : undefined;
                                return (_jsxs(Fragment, { children: [i > 0 && renderTableDivider(row.cellValues.length, MODAL_HEADER_BACKGROUND_COLOR), _jsx("tr", { onClick: onClick, css: trCss, children: row.cellValues.map((cellValue, i) => {
                                                const value = typeof cellValue === 'string' ? cellValue : cellValue.value;
                                                return (_jsx("td", { style: typeof cellValue === 'string' ? undefined : cellValue.style, children: value }, i));
                                            }) })] }, i));
                            }) })] })] }) }));
};
